namespace $ {
	export class $mol_hor extends $mol_view {
	}
	
}

